<template>
	<div id="reglist" class="sign-up-warp" style="padding-left: 30px; box-sizing: border-box">
		<div class="titleContainer">
			<div class="shu"></div>
			<div class="title">我的报名</div>
		</div>
		<div class="tableContainer">
			<el-table :data="meetlist" style="width: 100%" v-loading="loading">
				
				<el-empty description="暂无数据" slot="empty"></el-empty>
				
				<el-table-column prop="job_type" label="双选会名称" min-width="260" class-name="routeColumn">
					<template slot-scope="scope">
						<div class="item-main-box">
                            <div class="school-cover" v-if="scope.row.meeting_cover_img">
                            	<img class="school-cover__background" :src="scope.row.meeting_cover_img" alt="" @error="handleCoverImageError" />
                            	
                            </div>
							<div class="school-cover" v-else>
								<img class="school-cover__background" :src="getCoverBackgroundUrl(scope.row.id, currentpage - 1, scope.$index)" alt="" @error="handleCoverImageError" />
								<div class="school-cover__copy" :style="{ color: getCoverTextColor(scope.row.id, currentpage - 1, scope.$index) }">
								
									<template v-if="getSchoolNameSizeClass(scope.row.school_name) === 'two-line'">
										<div class="school-cover__name school-cover__name--two-line"
											v-for="(nameLine, lineIndex) in getSchoolNameLines(scope.row.school_name)" :key="lineIndex">
											{{ nameLine | replaceDot }}
										</div>
									</template>
									<div v-else class="school-cover__name" :class="'school-cover__name--' + getSchoolNameSizeClass(scope.row.school_name)">
										{{ scope.row.school_name | replaceDot }}
									</div>
										<div class="school-cover__season">秋季双选会</div>
								</div>
							</div>
							<div class="item-right" style="display: flex;align-items: center;">
							<div>
								<div class="item-1 " style="font-weight: 600;" :title="scope.row.meeting_name">
									{{scope.row.meeting_short_name || scope.row.meeting_name }}
								</div>
								<div v-if="scope.row.meeting_campus" style="margin-top: 8px;color: #999;font-size: 12px;text-align: left;">举办地点：{{scope.row.meeting_campus }}</div>
							</div>
							</div>
							<!-- <div class="item-1" style="color: #00956E;height: 20px;">
								{{ scope.row.meeting_price?'收费'+scope.row.meeting_price+'元':'免费' }}
							</div> -->
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="salary" label="举办时间" min-width="180" class-name="meetingTimeColumn">
					<template slot-scope="scope">
						<div class="holdingTime" style="font-weight: 600;">
								{{ scope.row.meeting_time}} {{scope.row.meeting_hour}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="job_name" label="举办形式" min-width="100" class-name="commonColumn">
					<template slot-scope="scope">
						<div class="" style="display: flex;align-items: center;justify-content: center;">
							<div class="meettype"
								style="font-weight: 600;cursor: pointer;color: #1E40AF;"
								@click="onLine(scope.row)">线上</div>
							<div style="display: flex;align-items: center;" v-if="scope.row.id!==3584 &&scope.row.meeting_cat==1">
								<div class="meettype" style="color: #1E40AF;font-weight: 600;margin-left: 2px;margin-right: 2px;" > + </div>
								<div class="meettype" style="cursor: pointer;color: #1E40AF;font-weight: 600;" v-if="scope.row.stand_position_url"
								 	@click="offline(scope.row)">线下</div>
								<el-tooltip  class="item" effect="dark" content="暂未公布会场展位图！" placement="bottom-start" v-else>
								     <div class="meettype" style="cursor: pointer;color: #1E40AF;font-weight: 600;"
								      	>线下</div>
								 </el-tooltip>
							</div>	
							 
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="job_end_time" label="报名截止" min-width="130" class-name="commonColumn" v-if="false">
					<template slot-scope="scope">
						<!--  -->
						<div class="deadline" v-if="scope.row.meeting_status !=5">
							<div class="deadline"
								v-if="(scope.row.meeting_status == 1)&&!scope.row.reg_end_time"
								>
								报名中 {{ scope.row.sDay > 0 ? '剩' + scope.row.sDay + '天' : '' }}
							</div>
							<div class="deadline" v-if="scope.row.meeting_status == 2" >
								报名结束
							</div>
							<div class="deadline"
								v-if="(scope.row.meeting_status == 6||scope.row.meeting_status == 4||scope.row.meeting_status == 1)&&scope.row.reg_end_time"
								>
								{{scope.row.reg_end_time}}
							</div>
						</div>
						<div class="deadline" v-else>{{ scope.row.reg_end_time }}</div>
					</template>
				</el-table-column>
				
				
				<el-table-column prop="meeting_price" label="费用" min-width="120" class-name="feeColumn commonColumn">
					<template slot-scope="scope">
						<div style="font-weight: 600;cursor: pointer;color: #1E40AF" v-if="scope.row.meeting_status == 5 || scope.row.stand_position_price" @click="openWebsite(scope.row)">
							官网缴费{{scope.row.stand_position_price=='' ||scope.row.stand_position_price==0?'':scope.row.stand_position_price+'元' }}
						</div>
						<div class="" style="font-weight: 600;" v-else-if="scope.row.true_meeting_price !== '' && scope.row.true_meeting_price != null">
							<div>{{formatMeetingPrice(scope.row.true_meeting_price, scope.row.adv_num)}}元</div>
                            <div class="original-fee">{{formatMeetingPrice(scope.row.meeting_price, scope.row.adv_num)}}元</div>
						</div>
						<div class="" style="font-weight: 600;" v-else-if="scope.row.meeting_price&&scope.row.meeting_price!='0'">
							{{formatMeetingPrice(scope.row.meeting_price, scope.row.adv_num)}}元
						</div>
						<div class="" style="font-weight: 600;" v-else>
							免费
						</div>
					</template>
				</el-table-column> 
				
				<!-- <el-table-column prop="stand_position_price" label="服务费" min-width="160" class-name="feeColumn commonColumn">
					<template slot-scope="scope">
						<div class="service-fee" style="font-weight: 600;" v-if="scope.row.paid_meeting_price * 1 > 0">
							{{scope.row.paid_meeting_price}}元
						</div>
						<div class="service-fee" style="font-weight: 600;" v-else-if="scope.row.paid_meeting_price * 1 < 0">
							<span class="unselected-fee">{{Math.abs(scope.row.paid_meeting_price * 1)}}元</span>（未缴）
						</div>
						<div class="service-fee" style="font-weight: 600;" v-else>免费</div>
					</template>
				</el-table-column> -->


				<el-table-column prop="job_end_time" label="状态" min-width="100" class-name="commonColumn">
					<template slot="header">
						<span>状态</span>
						<!-- <i class="el-icon-info" style="margin-left: 4px; cursor: pointer; color: #909399;" @click="showAuditTip"></i> -->
					</template>
					<template slot-scope="scope">
						<!-- <div class="" v-if="scope.row.meeting_status == 1" style="color: #0064fd">报名中 {{ scope.row.sDay > 0 ? '剩' + scope.row.sDay + '天' : '' }}</div>
            <div v-else-if="scope.row.meeting_status == 2" style="color: #999">{{}}</div> -->
						<div style="font-weight: 600;color:#333" v-if="Number(scope.row.meeting_cat) === 2">
							-
						</div>
						<div style="cursor: pointer;font-weight: 600;color:#0064FD" @click="handleClick(scope.row)"
							v-else-if="scope.row.audit_status==0||scope.row.audit_status==1">
							{{scope.row.meeting_status == 5 ? '审核中' : scope.row.audit_status_name}}
						</div>
						<div style="cursor: pointer;font-weight: 600;color:#059e6e" @click="handleClick(scope.row)"
							v-else-if="scope.row.audit_status==2">
							{{scope.row.audit_status_name}}
						</div>
						<div style="cursor: pointer;font-weight: 600;color:#F56C6C" @click="handleClick(scope.row)"
							v-else-if="scope.row.audit_status==3">
							{{scope.row.audit_status_name}}
						</div>
						<div style="font-weight: 600;color:#333" 
							v-else>
							-
						</div>

					</template>
				</el-table-column>

				<el-table-column fixed="right" label="操作" min-width="100" class-name="commonColumn">
					<template slot-scope="scope">
						<el-button class="compile" @click="toSign(scope)" type="primary">点击查看</el-button>

						<!-- <template v-if="scope.row.meeting_price && scope.row.order_no">
							<el-button class="compile" v-if="scope.row.invoice.length>0" @click="hint(scope.row.invoice[0].invoice_status)"
								:style="scope.row.registered?'opacity: 0.4':''"
								type="primary">{{scope.row.invoice[0].invoice_status|makeInvoice}}</el-button>
							<el-button class="compile" v-else @click="toInvoice(scope.row)" type="primary">去开票</el-button>
						</template> -->
						
						
						<!-- <el-button class="compile" v-if="scope.row.meeting_status == 1" @click="to(scope.row.id)">取消报名</el-button> -->
						<!-- <el-button class="compile" v-if="scope.row.meeting_status == 3" style="opacity: 0.4"
							@click="handleClick1(scope)" type="primary">点击查看</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			
			
			<!-- <div class="paging" style="padding: 20px 0;">
				<div class="" style="display: flex;align-items: center;">
					<div class="pagingLeft">
			
						<el-button @click="previousPage" :disabled='currentpage > 1?false:true'>上一页</el-button>
						<el-button @click="nextPage" :disabled='isNextPage?false:true'>下一页</el-button>
			
					</div>
				</div>
				<el-pagination background layout="prev, pager, next" :page-size="pageSizes" :total="total"
					@current-change="currentChange" :current-page="currentpage"> </el-pagination>
			</div> -->

		</div>
		
		
		
		<div class="preview">
			<el-dialog :visible.sync="dialogVisible" :show-close="false" width="500px">
				<div class="elDialog">
					<!-- <img class="close" @click="closeElDialog" src="../img/close.png" alt="" /> -->
					<div class="main">
						<!-- <div class="title">双选会预览</div> -->

						<div class="" style="font-weight: bold;font-size: 18px;text-align: center;color: #333333;">
							{{audit_status==2?'审核通过':audit_status==3?'审核未通过':meeting_price?'审核中':'审核中' }}
						</div>
						<div class="" style="display: flex;align-items: center;justify-content: center;margin:10px 0;">
							<img style="width:60px;height: 60px;" src="../img/audit2.png" alt=""
								v-if="audit_status==2" />
							<img style="width:60px;height: 60px;" src="../img/audit3.png" alt=""
								v-else-if="audit_status==3" />
							<img style="width:60px;height: 60px;" src="../img/audit1.png" alt="" v-else />
						</div>
						<div class=""
							style="font-weight: 500;font-size: 16px;color: #333333;text-align: center;margin-bottom: 20px;"
							v-if="!(applyItem.meeting_status == 5 && (audit_status == 0 || audit_status == 1))">
							<!-- {{audit_status==2?'恭喜您的报名审核通过':audit_status==3?'抱歉，您的报名未审核通过':'报名提交成功！我们将尽快进行审核' }} -->
							<!-- {{audit_status|official}} -->
							{{official}}
						</div>

					

						<div class=""
							style="background: #f7f8fc;border-radius: 10px;padding: 20px;box-sizing: border-box;"  v-if="audit_status!=3">
							<div class="" style="display: flex;align-items: center;margin-bottom: 10px;">
								<!-- <img src="../img/star2.png" alt=""
									style="width: 20px;height: 20px;margin-right: 10px;" /> -->
								<div class="" style="font-weight: bold;font-size: 18px;color: #333333;">
									温馨提示</div>
							</div>

							<div class=""
								style="font-weight: 500;font-size: 16px;color: #000;margin-bottom: 10px;line-height: 25px;">
								<strong>1、审核</strong></br>
								我们将尽快审核，审核结果在【我的报名】中查看。</br>
							</div>

							<div class=""
								style="font-weight: 500;font-size: 16px;color: #000;margin-bottom: 10px;line-height: 25px;">
								<strong>2、线上会场维护</strong></br>
								企业报名后，请及时返回平台首页完善企业主页、发布职位，活动期间积极登录小程序，及时回复学生消息和接收简历。</br>
								系统会根据HR活跃度，优先将您的岗位置顶并推荐给更多学生。
							</div>
							<div class=""
							style="font-weight: 500;font-size: 16px;color: #000;margin-bottom: 10px;line-height: 25px;" v-if="Number(meeting_price) > 0&&isinvoice&&applyItem.order_no">
								 3、如需开票，<span @click="goInvoice" style="text-decoration: underline;color: blue;cursor: pointer;">请输入开票信息</span>
							</div>
						</div>
						<div class=""
							style="background: #f7f8fc;border-radius: 10px;padding: 20px;box-sizing: border-box;margin-bottom: 20px;">
							<div class=""
								style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;">
								<img style="width:150px;height: 150px;border: 4px solid #059E6E;border-radius: 10px;"
									:src="qrcodeImg" alt="" />
							</div>
							<div class=""
								style="font-weight: 500;font-size: 16px;color: #606266;text-align: center;margin-bottom: 10px;">
								如需帮助，欢迎扫码联系客服。
							</div>
							<!-- <div class="" style="font-weight: 500;font-size: 16px;color: #606266;text-align: center;">
								{{audit_status==2?'以便获取最新的会务服务':audit_status==3?'以便获取最新的会务服务':'以便获取审核结果和会务服务'}}
							</div> -->
						</div>
						<div class="" style="display: flex;align-items: center;justify-content: center;margin-top: 20px;">
							<el-button type="primary" @click="dialogVisible = false" style="height: 40px;width: 420px;" >确定</el-button>
						</div>
						
					</div>
				</div>
			</el-dialog>
		</div>





		<div class="previewDialogVisible">
			<el-dialog :visible.sync="dialogVisible1" :show-close='false' width="800px"
				class="previewDialogVisible">
				<div class="previewElDialog">
					<img class="close" @click="closeElDialog1" src="../img/close.png" alt="" />
					<div class="main">
						<div class="title">线上会场码</div>
						<div class="qrcodeContainer">
							<div class="qrcode">
								<div class="qrcodeImage" v-if="qrcodeImg1">
									<img class="qrcodeImg" :src="qrcodeImg1" alt="" />
									<img class="qrcodeLogo" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/02/logopt.png" alt="" />
								</div>
								<div class="hite1">扫二维码进入线上会场</span></div>
								<!-- <div class="hite2">可在手机上预览</div> -->
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>
		

		<div class="changePassword">
			<el-dialog title="填写发票信息" :visible.sync="invoice" @close='elDialogClose1' width="500px">
				<div class="elDialogContainer">
					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							发票类型
						</div>
						<el-select v-model="invoice_type" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							开票金额
						</div>
						<!-- 0.01|| -->
						<el-input disabled v-model="invoice_amount" :placeholder="invoiceAmountLoading ? '正在获取开票金额' : '暂无开票金额'"></el-input>
					</div>
					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							名称
						</div>
						<el-input  v-model="card_title"  placeholder="抬头名称（必填）"></el-input>
					</div>
					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							税号
						</div>
						<el-input v-model="card_number" maxlength="19" placeholder="纳税人识别号（必填）" @input="handleTaxNoInput"></el-input>
					</div>
					
					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							单位地址
						</div>
						<el-input  v-model="card_address"  :placeholder="invoice_type==1?'公司地址（必填）':'公司地址'"></el-input>
					</div>
					
					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							电话号码
						</div>
						<el-input  v-model="card_tel"  :placeholder="invoice_type==1?'公司电话（必填）':'公司电话'"></el-input>
					</div>
					
					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							开户银行
						</div>
						<el-input  v-model="card_bank"  :placeholder="invoice_type==1?'开户银行（必填）':'开户银行'"></el-input>
					</div>
					
					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							银行账户
						</div>
						<el-input  v-model="card_bank_num"  :placeholder="invoice_type==1?'银行账户（必填）':'银行账户'"></el-input>
					</div>
					
					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							接收邮箱
						</div>
						<el-input  v-model="card_mail"  placeholder="发票接收邮箱（必填）"></el-input>
					</div>
					
				</div>
				<div class="" style="display: flex;align-items: center;justify-content: flex-end;">
					<el-button type="primary" @click="saveForm">保存</el-button>
				</div>
			</el-dialog>
		</div>



	</div>
</template>
<script>
	import {
		mapMutations,
		mapState
	} from 'vuex'
	import npRequest from '@/utils/nprequest'
	const config = require('../../WebConfig')
	export default {
		data() {
			return {
				envConfig: config,
				meetlist: [],
				loading: false,
				dialogVisible: false,
				qrcodeImg: '',
				provinceImgList: null,
				audit_status: 0,
				isinvoice:false,

				previewDialogVisible: false,
				meetId: null,

				invoice: false,



				options: [{
					value: 0,
					label: '数字化电子普票（电子）'
				}, {
					value: 1,
					label: '数字化电子专票（电子）'
				}],
				
				invoice_status: 1,//发票状态
				invoice_type: 0,//发票类型
				meeting_price: null,//发票金额
				card_title:'',//企业名称
				card_number:'',//税号
				card_address:'',//公司地址
				card_tel:'',//电话号码
				card_bank:'',//开户银行
				card_bank_num:'',//银行卡账号
				card_mail:'',//接收邮箱
				order_no:'',
				invoice_amount: null,
				invoiceAmountLoading: false,
				
				
				applyItem:{},
				
				dialogVisible1:false,
				
				qrcodeImg1:'',
				
				total: 0,
				pageSizes: 10,
				currentPage: 1,
				currentpage: 1,
				request:false,
				timer:null,
			}
		},
		filters: {
			replaceDot(val){
				if(val){
					return val.replace('（','(').replace('）',')')
				}else{
					return val
				}
			},
			jobType(val) {
				switch (val) {
					case 1:
						return '全职'
					case 2:
						return '实习'
					case 3:
						return '兼职'
					default:
						return '全职'
				}
			},
			salary(val) {
				if (val) {
					return val
				} else {
					return '面议'
				}
			},
			makeInvoice(val) {
				switch (Number(val)) {
					case 1:
						return '开票中'
						break;
					case 2:
						return '已开票'
						break;
					case 3:
						return '驳回开票'
						break;
					default:
						break;
				}
			},
			
		},
		mounted() {
			// this.dialogVisible = true
			this.getMySchoolMeeting()

			console.log('schoolInfo', this.schoolInfo)
		},
		computed: {
			...mapState({
				nextToken: (state) => state.nextToken,
				userInfo: (state) => state.userInfo,
				schoolInfo: (state) => state.schoolData,
			}),
			isNextPage() {
				// total
				// pageSizes
				// currentpage
				console.log(this.currentpage)
				console.log(Math.ceil(this.total / this.pageSizes))
				if (this.currentpage == Math.ceil(this.total / this.pageSizes)) {
					return false
				} else {
					return true
				}
			},
			official(){
				// const meeting_price = this?.meeting_price || {};
				switch (Number(this.audit_status)){
					case 2:
						return '恭喜您的报名审核通过'
					case 3:
						return '抱歉，您的报名未审核通过'
						break;
					default:
					let str = ''
					if(this.meeting_price){
						str = '报名提交成功！我们将尽快进行审核'
					}else{
						str = '报名提交成功！我们将尽快进行审核' 
					}
					return str
						break;
				}
			}
		},
		methods: {
			formatMeetingPrice(price, advNum) {
				const quantity = Number(advNum)
				if (quantity > 1) {
					return Number((Number(price) * quantity).toFixed(2))
				}
				return price
			},
			...mapMutations(['setIslogin']),
			showAuditTip() {
				this.$alert('高校陆续审核中，部分高校会在报名截止后统一处理', '提示', {
					confirmButtonText: '我知道了',
					customClass: 'audit-tip-message',
					showClose: false
				})
			},
			getCoverTemplateIndex(id) {
				const numericId = Math.abs(Number(id))
				if (!Number.isFinite(numericId) || numericId <= 0) return 1
				const fixedTemplates = { 540511: 7, 540611: 11, 540711: 54, 540811: 16  }
				if (fixedTemplates[numericId]) return fixedTemplates[numericId]
				const rawIndex = numericId % 70 || 70
				return ((rawIndex - 1) * 37 + 17) % 70 + 1
			},
			getCoverTemplateIndexByPosition(id) {
				return this.getCoverTemplateIndex(id)
			},
			getCoverBackgroundUrl(id, groupIndex, itemIndex) {
				const templateIndex = this.getCoverTemplateIndexByPosition(id, groupIndex, itemIndex)
				return `https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/07/01/bb${templateIndex}.png`
			},
			getSchoolNameSizeClass(schoolName) {
				const length = (schoolName || '').replace(/[\s（）()]/g, '').length
				if (length > 12) return 'two-line'
				if (length > 8) return 'small'
				if (length > 5) return 'medium'
				return 'large'
			},
			getSchoolNameLines(schoolName) {
				const name = schoolName || ''
				const length = name.replace(/[\s（）()]/g, '').length
				if (length <= 12) return [name]

				const firstLineLength = Math.floor((length - 2) / 2)
				let currentLength = 0
				let firstLine = ''
				let secondLine = ''
				let isSecondLine = false
				const nameParts = name.match(/（[^）]*）|\([^)]*\)|./g) || []

				nameParts.forEach((namePart) => {
					const partLength = namePart.replace(/[\s（）()]/g, '').length
					if (!isSecondLine && currentLength > 0 && currentLength + partLength > firstLineLength) {
						isSecondLine = true
					}
					if (isSecondLine) {
						secondLine += namePart
					} else {
						firstLine += namePart
					}
					if (!isSecondLine) currentLength += partLength
				})

				return [firstLine, secondLine]
			},
			getCoverTextColor(id, groupIndex, itemIndex) {
				const textColors = {
					1: '#7A4A00', 2: '#14532D', 3: '#0B3D91', 4: '#9A3412', 5: '#065F46',
					6: '#FFFFFF', 7: '#FFFFFF', 8: '#FFFFFF', 9: '#831843', 10: '#14532D',
					13: '#FFFFFF', 18: '#166534', 19: '#6D28D9', 20: '#5B3217', 21: '#7E1F4D',
					35: '#0090ff', 36: 'blue', 47: '#000000', 49: '#000000', 50: '#000000', 52: '#FFFFFF', 55: '#000000', 56: '#000000', 60: '#000000', 61: '#FFFFFF', 66: '#FFFFFF', 68: '#000000', 69: '#000000'
				}
				const templateIndex = this.getCoverTemplateIndexByPosition(id, groupIndex, itemIndex)
				if (textColors[templateIndex]) return textColors[templateIndex]
				if (templateIndex >= 31) return '#FFFFFF'
				if (templateIndex >= 11) return '#704A09'
				return '#000000'
			},
			handleCoverImageError(event) {
				event.target.style.display = 'none'
			},
			onLine(row) {
				this.dialogVisible1 = true
				// &is_test=1
				this.$util.post(
					`admin/home/qrcode?app_type=10&not_login=1&page_path=pages/courseware/meeting&id=${row.id}&is_test=${config.IS_TEST}`, {
					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg1 = res.data.qrCode
						}
					}
				)
			},
			offline(row) {
				if(row.stand_position_url){
					window.open(row.stand_position_url, '_blank')
				}
			},
			openWebsite(row) {
				if(row.website){
					window.open(row.website, '_blank')
				}
			},
			hint(val){
				switch (Number(val)) {
					case 1:
						// return '开票中'
						this.$message({
							type: 'info',
							message: '正在开票中，请耐心等待！',
						})
						break;
					case 2:
						this.$message({
							type: 'info',
							message: '发票已开具完成，请在邮箱中查看',
						})
						break;
					case 3:
						// return '发票信息有误，已被驳回'
						this.$message({
							type: 'info',
							message: '发票信息有误，已被驳回',
						})
						break;
					default:
						break;
				}
			},
			isDebounce(duration = 500) {
			return new Promise(resolve => {
			  // 如果已有定时器，清除（重新计时）
			  if (this.timer) {
			    clearTimeout(this.timer);
			  }
			    // 开启新定时器
			    this.timer = setTimeout(() => {
			      resolve(); // 时间到 → 放行
			    }, duration);
			  });
			},
			async saveForm(){
				if (this.request) return
				if (this.invoiceAmountLoading || this.invoice_amount === null || this.invoice_amount === '') {
					this.$message.error('未获取到开票金额，请稍后重试')
					return
				}
				if (this.card_title.trim() == '') {
					this.$message.error('请输入发票抬头名称');
					return
				}
				if (this.card_number.trim() == '') {
					this.$message.error('请输入纳税人识别号');
					return
				}
				if (!/^[A-Za-z0-9]{14,19}$/.test(this.card_number)) {
					this.$message.error('纳税人识别号仅支持15-18位字母或数字');
					return
				}
				if(this.invoice_type==1){
					
					if (this.card_address.trim() == '') {
						this.$message.error('请输入单位地址');
						return
					}
					if (this.card_tel.trim() == '') {
						this.$message.error('请输入单位电话');
						return
					}
					if (this.card_bank.trim() == '') {
						this.$message.error('请输入单位开户银行');
						return
					}
					if (this.card_bank_num.trim() == '') {
						this.$message.error('请输入单位开户银行账号');
						return
					}
				}
				
				let card_mail = this.card_mail.trim()
				const regex =  /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/i
				if(!regex.test(card_mail)){
					this.$message.error('请输入正确格式的邮箱')
				    return
				}
				
				this.$confirm(`请仔细核对开票信息，开票成功后，发票将发送到您的邮箱。`, '确认开票', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						showClose: true,
						type: 'warning',
					})
					.then(() => {
						if (this.request) return
						this.request = true
						let obj = {
						    admin_id: this.schoolInfo.admin_id,
						    order_no: this.order_no,
							invoice_type: this.invoice_type==0?'数字化电子普票（电子）':'数字化电子专票（电子）',
						    unit_name: this.card_title,
						    tax_no: this.card_number,
						    unit_addr: this.card_address,
						    telephone: this.card_tel,
						    deposit_bank: this.card_bank,
						    bank_account: this.card_bank_num,
							// 0.01|| 
							order_amount:this.invoice_amount,
						    email: card_mail,
						    invoice_status: 1
						    // meeting_id:this.meetId || 0
						}
						console.log(obj)
						this.$util.post(
							`v2/school_job/invoice`, {
								...obj
							},
							(res) => {
								if(Number(res.code) === 200){
									this.$message({
										type: 'success',
										message: '发票提交成功',
									})
									
									this.invoice = false
									this.isinvoice = false
									this.getMySchoolMeeting()
									this.invoice1(obj)
								}else{
									this.$message({
										type: 'error',
										message: '发票提交失败',
									})
								}
							}, () => {
								this.request = false
							}
						)
						
					})
					.catch((err) => {
						this.request = false
						console.log(err)
						// this.$message({
						// 	type: 'info',
						// 	message: '已取消',
						// })
					})
				
				
			},
			invoice1(obj){
				this.$util.post(
					`v2/school_job/SaveInvoiceInfo`, {
						...obj
					},
					(res) => {
						
						
					}
				)
			},
			handleTaxNoInput(value) {
				this.card_number = (value || '').replace(/[^A-Za-z0-9]/g, '').slice(0, 19)
			},
			elDialogClose1() {
				this.invoice = false
			},
			goInvoice(){
				this.$util.post(
					`v2/school_job/getInvoiceInfoList`, {
						admin_id: this.schoolInfo.admin_id,
					},
					(res) => {
						if (res.code == 200) {
							if(res.data.length>0){
								console.log(res)
								this.card_number = res.data[0].tax_no
								this.card_address = res.data[0].unit_addr
								this.card_mail = res.data[0].email
								this.card_tel = res.data[0].telephone
								this.card_bank = res.data[0].deposit_bank
								this.card_bank_num = res.data[0].bank_account
							}
						}
					}
				)
				this.audit_status = this.applyItem.audit_status
				this.card_title = this.schoolInfo.company_name
				this.meeting_price = this.applyItem.meeting_price
				this.order_no = this.applyItem.order_no
				this.invoice_amount = null
				this.invoiceAmountLoading = true
				this.invoice = true
				npRequest.post('https://np-admin.sx985.com/npapi/admin/uni/order_list', {
						keyword: this.order_no
				}).then((res) => {
					const orderList = res && res.data && Array.isArray(res.data.data) ? res.data.data : []
					const order = orderList.find(item => item.order_no === this.order_no) || orderList[0]
					if (order && order.pay_price !== undefined && order.pay_price !== null) {
						this.invoice_amount = order.pay_price
					} else {
						this.$message.error('未查询到订单支付金额')
					}
					this.invoiceAmountLoading = false
				}).catch(() => {
					this.invoiceAmountLoading = false
					this.$message.error('获取开票金额失败，请稍后重试')
				})
			},
			toInvoice(row) {
				console.log(row)
				this.audit_status = row.audit_status
				this.card_title = this.schoolInfo.company_name
				this.meeting_price = row.meeting_price || null
				this.order_no = row.order_no
				this.invoice = true
			},
			previewCloseElDialog() {
				this.previewDialogVisible = false
			},
			toSign(scope) {
				if(scope.row.id==3584){
					// this.onLine({
					// 	id:3584
					// })
                    this.$router.push({
                    	path: '/corporateApply'
                    })
					return
				}
				
				// if (scope.row.academy_id == 0) {
				// 	this.previewDialogVisible = true
				// } else {
					
				// }
				let item = scope.row
				console.log('id', item)
				let obj = {
					meetId: item.id,
					school_name: item.school_name || '',
					lat: item.work_lat || '',
					lng: item.work_lng || '',
					meeting_address: item.meeting_address || '',
					pdf_url: item.pdf_url || '',
					meeting_name: item.meeting_name || '',
					sign_up_img: item.sign_up_img || '',
					sign_time: item.meeting_time + ' ' + item.meeting_hour,
					meeting_price: item.meeting_price,
					paid_meeting_price:item.paid_meeting_price || '',
					meeting_short_name:item.meeting_short_name || '',
					meeting_cat: item.meeting_cat
				}
				
				if(scope.row.meeting_status == 6){
					obj.isOther = true
					obj.meeting_price = ''
				}
				if(scope.row.meeting_cat_m == '线上'){
					obj.isSpecial = true
					obj.meeting_price = ''
				}
				
				sessionStorage.setItem('meetObj', JSON.stringify(obj))
				sessionStorage.setItem('selectMeetList', JSON.stringify([item]))
				// this.$uniapp.goPage(`/pages/service/signup?meetId=${item.id}&school_name=${item.school_name||''}&lat=${item.work_lat||''}&lng=${item.work_lng||''}&meeting_address=${item.meeting_address||''}&pdf_url=${item.pdf_url || ''}&meeting_name=${item.meeting_name||''}&sign_up_img=${item.sign_up_img}`)
				// sessionStorage.setItem('user', JSON.stringify({ name: 'Alice', id: 123 }));
				
				this.$router.push({
					path: '/signup',
					query: {
					  isinvoice:scope.row.invoice.length>0?true:false,
					},
				})
			},
			getCitysList() {
				// `https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/21/dgsgbkjfkmzswgvs.json?${Math.random()}`
				this.$util.get1(
					`https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/21/dgsgbkjfkmzswgvs.json?${Math.random()}`, {},
					(res) => {
						console.log(this.meetId)
						if (res['mid_' + this.meetId]) {
							this.qrcodeImg = res['mid_' + this.meetId]
						} else {
							let province = ''
							console.log(this.schoolInfo.company_name)
							console.log(res)
							res.provinces.forEach(item => {
								item.citys.forEach(i => {
									if (this.schoolInfo.company_name.indexOf(i.cityName) > -1 || this
										.schoolInfo.company_name.indexOf(item.provinceName) > -1) {
										province = item.provinceName
									}
								})
							})

							this.provinceImgList = res.qrcodeImgs
							if (this.provinceImgList[province]) {
								this.qrcodeImg = this.provinceImgList[province]
							} else {
								this.qrcodeImg =
									'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/21/wv4br98vawxpxkei.png'
							}
						}



					}
				)
			},
			beforeUpload() {},
			getMySchoolMeeting() {
				this.loading = true
				let obj = {
					admin_id: this.schoolInfo.admin_id,
				}
				this.$util.post('v2/school_job/getMySchoolMeeting', obj, (res) => {
					if (res.code === 200) {
						res.data.forEach((item) => {
							if (item.reg_end_time) {
								item.sDay = this.getDaysUntilNextYear('2025-' + item.reg_end_time)
							} else {
								item.sDay = this.getDaysUntilNextYear('2025-' + item.meeting_time)
							}
							// item.meeting_status = '2'
						})
						this.meetlist = res.data
						this.loading = false
						console.log('meetlist', this.meetlist)
					}
				},(err)=>{
						console.log(err)
						this.loading = false
					})
			},
			closeElDialog() {
				this.dialogVisible = false
			},
			closeElDialog1(){
				this.dialogVisible1 = false
			},
			getQrcode(uri) {
				this.$util.post(uri, {
						// app_type: 10,
						// page_path: 'pages/recruit/jobdetail',
						// id:id
					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg = res.data.qrCode
							// this.sceneId = res.data.scene
							// this.setTimer()
							// localStorage.setItem('qrcodeImg', res.data.qrCode)
						}
					}
				)
			},
			handleClick(row) {
				this.applyItem = row
				this.audit_status = row.audit_status
				this.meeting_price = row.meeting_price || null
				this.isinvoice = row.invoice.length>0?false:true
				console.log(this.meeting_price)
				console.log(row)
				this.meetId = row.id
				// let uri =
				// 	`admin/home/qrcode?app_type=10&not_login=1&page_path=pages/service/registration&id=${this.schoolInfo.admin_id}&audit_status=${row.audit_status}`
				// this.getQrcode(uri)
				this.dialogVisible = true
				this.getCitysList()
				// this.$router.push({
				// 	path: "/jobDetails",
				// 	// query: {
				// 	//   id: 1,
				// 	// },
				// });
			},
			handleClick1(scope) {
				let id = scope.row.id
				console.log('id', id)
				console.log('ids', scope.row)

				// meetId=2021&banner_img=${scope.row.banner_img}
				// &is_test=1
				let uri = `admin/home/qrcode?app_type=10&not_login=1&page_path=pages/courseware/meeting&id=${id}&is_test=${config.IS_TEST}`
				this.getQrcode(uri)
				this.dialogVisible = true
			},
			getDaysUntilNextYear(days) {
				const now = new Date() // 当前日期和时间
				const nextYear = new Date(days.replace(/-/g, '/')) // 明年的同一天
				const diffTime = nextYear.getTime() - now.getTime() // 获取两个日期的毫秒差
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) // 将毫秒转换为天数
				return diffDays
			},
			
			
			currentChange(page) {
				console.log(page)
				this.currentpage = page
				// this.currentpage = page
				// this.getEnterpriseList()
				this.getMySchoolMeeting()
			},
			previousPage() {
				if (this.currentpage > 1) {
					this.currentpage = this.currentpage - 1
					this.getMySchoolMeeting()
				}
			},
			nextPage() {
				if (Math.ceil(this.total / this.pageSizes) > this.currentpage) {
					this.currentpage++
					this.getMySchoolMeeting()
			
				} else {
					this.isnextPage = false
				}
			},
		},
		components: {},
	}
</script>
<style>
	#reglist .tableContainer .delete .el-button--primary {
		background-color: #dc7777;
		border-color: #dc7777;
	}

	#reglist .tableContainer {
		width: 98%;
		height: 602px;
	}

	#reglist .tableContainer .el-table__header th {
		background: #e9eeff;
		font-weight: bold !important;
		color: #2a2929 !important;
	}

	#reglist .el-table .el-table__body td {
		background: #f9fbff;
	}

	#reglist .el-table .cell {
		text-align: center;
	}

	#reglist .preview .el-dialog {
		background: initial;
		box-shadow: initial;
	}
	
	#reglist .preview .el-dialog{
		transform:scale(.8);
	}
	#reglist .el-table .el-table__cell{
		text-align: center;
	}
	
	#reglist .payFees {
		width: 100% !important;
		color: #000000;
		background-color: #ffffff !important;
		border-color: #ffffff !important;
		cursor: auto;
	}

	.audit-tip-message .el-message-box__title,
	.audit-tip-message .el-message-box__message,
	.audit-tip-message .el-message-box__btns {
		text-align: center;
	}
</style>
<style lang="less" scoped>
	.titleContainer {
		display: flex;
		align-items: center;
		margin-bottom: 30px;
		margin-top: 20px;

		.shu {
			width: 2px;
			height: 13px;
			background: #1472ff;
			margin-right: 7px;
		}

		.title {
			font-weight: bold;
			font-size: 16px;
			color: #333333;
		}
	}

	.item-main-box {
		display: flex;
		align-items: center;

		.school-cover {
			position: relative;
			flex-shrink: 0;
			width: 108px;
			height: 72px;
			overflow: hidden;
			background: #f5f5f5;
		}

		.school-cover__background {
			position: absolute;
			inset: 0;
			z-index: 1;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		.school-cover__copy {
			position: relative;
			z-index: 2;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			justify-content: center;
			width: 100%;
			height: 100%;
			padding: 4px 0 7px;
			font-family: Arial, "Microsoft YaHei", "PingFang SC", sans-serif;
			font-weight: 700;
			text-align: center;
		}

		.school-cover__season {
			font-size: 12px;
			font-weight: 900;
			line-height: 18px;
		}

		.school-cover__name {
			display: block;
			margin-top: 1px;
			overflow: hidden;
			font-weight: 700;
			white-space: nowrap;
		}

		.school-cover__name--large { font-size: 14px; line-height: 16px; }
		.school-cover__name--medium { font-size: 12px; line-height: 14px; }
		.school-cover__name--small { font-size: 10px; line-height: 10px; }
		.school-cover__name--two-line { font-size: 10px; line-height: 13px; white-space: nowrap; }

		> img {
			width: 90px;
			height: 72px;
			border-radius: 2px;
		}

		.item-right {
			flex: 1;
			padding-left: 10px;
			box-sizing: border-box;

			.item-1 {
				text-align: left;
				// height: 38px;
				// line-height: 18px;
				color: #000000;
				font-weight: 400;
			}

			.item-2 {
				text-align: left;
				// margin-top: 20px;
				color: #000000;
				font-weight: 400;

				b {
					color: #1e68ff;
				}
			}
		}
	}

	.preview {
		.text {
			font-weight: 400;
			font-size: 14px;
			color: #2a2929;
			// margin-bottom: 5px;
		}

		.btn {
			font-weight: 400;
			font-size: 14px;
			color: #004eff;
			cursor: pointer;
		}
	}

	.elDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 30px 20px 50px 20px;
			background: #ffffff;
			border-radius: 10px;

			.title {
				font-weight: bold;
				font-size: 16px;
				color: #2a2929;
				margin-bottom: 30px;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}

	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.qrcode {
			padding: 50px 50px;
			// width: 410px;
			// height: 390px;
			background: #ffffff;
			border-radius: 10px;
			border: 4px solid #0084ff;

			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;

			.qrcodeImage { position: relative; width: 208px; height: 245px; }
			.qrcodeImg {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
			}
			.qrcodeLogo { position: absolute; top: 0; left: 0; right: 0; width: 90px; height: 90px; border-radius: 50%; margin: 58px auto; }

			.hite1 {
				font-weight: bold;
				font-size: 16px;
				color: #333333;
				margin-bottom: 17px;
			}

			.hite2 {
				font-weight: 500;
				font-size: 16px;
				color: #333333;
			}
		}
	}



	#reglist .previewDialogVisible .el-dialog {
		background: initial;
		box-shadow: initial;
	}

	.previewElDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 30px 50px 50px 50px;
			background: #FFFFFF;
			border-radius: 10px;

			.title {
				font-weight: bold;
				font-size: 24px;
				color: #2A2929;
				margin-bottom: 30px;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}







	#reglist .changePassword {
		.elDialogContainer {

			.ipt {
				width: 100%;
				display: flex;
				align-items: center;
				margin-bottom: 20px;
				border: 1px solid #DCDFE6;
				border-radius: 4px;
				padding: 0 15px;

				.text {
					// width: 135px;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: 16px;
					color: #343232;
				}

				.el-input {
					flex: 1 !important;
				}

				.el-select {
					flex: 1 !important;
				}

				.el-textarea {
					flex: 1 !important;
				}
			}
		}
	}






	#reglist .changePassword {
		display: flex;
		align-items: center;

		.uploadText {
			width: 310px;
			font-weight: 500;
			font-size: 14px;
			color: #999999;
		}
	}
	
	#reglist .deadline{
		font-weight: 600;
		white-space: nowrap;
	}

	#reglist .service-fee {
		white-space: nowrap;
	}

	#reglist .unselected-fee {
		text-decoration: line-through;
	}

	#reglist .original-fee {
		color: #999;
		// font-weight: 400;
		text-decoration: line-through;
	}
</style>
